/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
    IonRow,
    IonCol,
    IonCard,
    IonIcon,
    IonBadge,
    IonButton,
    useIonViewDidEnter,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonContent,
    useIonLoading,
    useIonAlert,
} from "@ionic/react";
import {
    documentOutline,
    notificationsOutline,
    fileTrayFullOutline,
    laptopOutline,
    readerOutline,
    warning,
    checkmarkCircle,
    cartOutline,
    shieldCheckmark,
    bodyOutline,
} from "ionicons/icons";
import { useNotification } from "../../context/Notifications";
import PageWrapper from "../layouts/PageWrapper";
import { useAuth } from "../../context/Auth";
import { fetchUnpaidInvoices } from "../../services/InvoiceServices";
import {
    getActivatedDocuments,
    postActivateDocument,
    fetchPendingDocuments, // Import the new function
} from "../../services/DocumentServices";
import PhotosViewerModalWithSwiper from "../../components/PhotosViewerModalWithSwiper";
import { useStatements } from "../../hooks/useStatements";

import logo from "../../assets/images/logo.svg";
import "./DashboardPage.scss";
import { useHistory } from "react-router";

const DashboardPage: React.FC = () => {
    const history = useHistory();
    const { unreadNotifictaions } = useNotification();
    const [presentLoading, dismissLoading] = useIonLoading();
    const [presentAlert] = useIonAlert();
    const { checkAxiosError, assigns } = useAuth();

    const [unpaidInvoices, setUnpaidInvoices] = useState<any>(null);
    const [activatedDocuments, setActivatedDocuments] = useState<any>([]);
    const [pendingDocuments, setPendingDocuments] = useState<any[]>([]); // State for pending documents
    const [selectedActivatedDocument, setSelectedActivatedDocument] =
        useState<any>(undefined);
    const [selectedDocumentId, setSelectedDocumentId] = useState<string | null>(
        null
    ); // State for selected document
    const { fetchStatements } = useStatements();

    useEffect(() => {
        fetchStatements();
    }, []);

    const getUnpaidInvoices = () => {
        fetchUnpaidInvoices()
            .then((res: any) => {
                if (res.data.error === false) {
                    setUnpaidInvoices(res.data.data);
                }
            })
            .catch((err: any) => {
                checkAxiosError(err);
            });
    };

    const fetchActivatedDocuments = () => {
        getActivatedDocuments()
            .then((res: any) => {
                if (res.data.error === false) {
                    setActivatedDocuments(res.data.data);
                }
            })
            .catch((err: any) => {
                checkAxiosError(err);
            });
    };

    // Function to fetch pending documents
    const fetchPendingDocumentsData = () => {
        fetchPendingDocuments()
            .then((res: any) => {
                if (res.data.error === false) {
                    setPendingDocuments(res.data.data);
                }
            })
            .catch((err: any) => {
                checkAxiosError(err);
            });
    };

    const handleActivateDocument = (id: string) => {
        presentLoading("Kérem várjon...");
        postActivateDocument(id)
            .then((res: any) => {})
            .catch((err: any) => {
                checkAxiosError(err);
            })
            .finally(() => {
                setSelectedActivatedDocument(undefined);
                dismissLoading();
                fetchActivatedDocuments();
            });
    };

    // Handle the "Sign" button click
    const handleSignDocument = (doc: any) => {
        if (!doc.is_first_relation) {
            presentAlert({
                header: "Hiba",
                message:
                    "A dokumentumot csak a partnerhez elsődlegesen hozzárendelt felhasználó írhatja alá!",
                buttons: ["OK"],
            });
        } else {
            // Open the DocumentViewer modal
            setSelectedDocumentId(doc.id);
        }
    };

    const handleDocumentAction = () => {
        fetchPendingDocumentsData();
        getUnpaidInvoices();
        fetchActivatedDocuments();
    };

    useIonViewDidEnter(() => {
        getUnpaidInvoices();
        fetchActivatedDocuments();
        fetchPendingDocumentsData(); // Fetch pending documents on component mount
        setSelectedActivatedDocument(undefined);
    });

    return (
        <>
            <PageWrapper>
                <div className="hasButton">
                    <h1 className="pageTitle">Főoldal</h1>
                    <IonButton
                        size="small"
                        color="success"
                        routerLink="/assign"
                        routerDirection="none"
                    >
                        Új hozzárendelés
                    </IonButton>
                </div>

                <div id="desktopWelcome">
                    <h2>Üdv a myPatent alkalmazásban!</h2>
                    <p>
                        Bármilyen hibát talált kérem jelezze a{" "}
                        <a href="mailto:hello@mypatent.hu">hello@mypatent.hu</a>{" "}
                        címen! Köszönjük!
                    </p>
                </div>

                {/* Pending Documents Alerts */}
                {pendingDocuments.length > 0
                    ? pendingDocuments.map((doc: any) => (
                          <IonRow key={doc.id}>
                              <IonCol size="12">
                                  <IonCard
                                      className="cardButton alert"
                                      button
                                      onClick={() => handleSignDocument(doc)}
                                  >
                                      <div className="pendingDocumentAlert">
                                          <div className="alertContent">
                                              <IonIcon icon={documentOutline} />
                                              <div>
                                                  <h2>
                                                      Aláírandó dokumentuma
                                                      érkezett
                                                  </h2>
                                                  <h2>{doc.title}</h2>
                                              </div>
                                          </div>
                                          <IonButton
                                              onClick={(e) => {
                                                  e.stopPropagation(); // Prevent the event from bubbling up to the card
                                                  handleSignDocument(doc);
                                              }}
                                              color="primary"
                                          >
                                              Aláírás
                                          </IonButton>
                                      </div>
                                  </IonCard>
                              </IonCol>
                          </IonRow>
                      ))
                    : null}

                {/* Unpaid Invoices Alert */}
                {unpaidInvoices !== null ? (
                    <IonRow>
                        <IonCol size="12">
                            <IonCard
                                button={true}
                                className="cardButton alert"
                                onClick={() => {
                                    if (unpaidInvoices > 0) {
                                        history.push('/my/invoices?unpaid=yes');
                                    } else {
                                        history.push('/my/invoices');
                                    }
                                }}
                            >
                                {unpaidInvoices > 0 ? (
                                    <div className="invoiceAlert">
                                        <IonIcon icon={warning} />
                                        <h2>
                                            Fizetetlen számlák:{" "}
                                            <strong>
                                                <NumberFormat
                                                    value={unpaidInvoices}
                                                    displayType={"text"}
                                                    thousandSeparator={" "}
                                                    suffix={" Ft"}
                                                    decimalScale={0}
                                                />
                                            </strong>
                                        </h2>
                                    </div>
                                ) : (
                                    <div className="invoiceAlert success">
                                        <IonIcon icon={checkmarkCircle} />
                                        <h2>Nincs fizetetlen számla!</h2>
                                    </div>
                                )}
                            </IonCard>
                        </IonCol>
                    </IonRow>
                ) : null}

                {/* Activated Documents Alerts */}
                {activatedDocuments.length > 0 ? (
                    <>
                        {activatedDocuments.map((a: any) => (
                            <IonRow key={a.id}>
                                <IonCol size="12">
                                    <IonCard
                                        button={true}
                                        className="cardButton alert"
                                        onClick={() =>
                                            setSelectedActivatedDocument(a)
                                        }
                                    >
                                        <div className="invoiceAlert full">
                                            <IonIcon icon={shieldCheckmark} />
                                            <h2>
                                                Szolgáltatás aktiválása:{" "}
                                                {a.related.U_Sorszam} -{" "}
                                                {a.related
                                                    .U_myPatentObjektumCim ??
                                                    "-"}
                                            </h2>
                                        </div>
                                    </IonCard>
                                </IonCol>
                            </IonRow>
                        ))}
                    </>
                ) : null}

                {/* <PhotosViewerModal /> */}

                <IonRow>
                    <IonCol size="6" sizeMd="3" sizeLg="4">
                        <IonCard
                            button={true}
                            className="cardButton"
                            routerLink="/my/notifications"
                            routerDirection="forward"
                        >
                            {unreadNotifictaions > 0 && (
                                <IonBadge color="danger">
                                    {unreadNotifictaions}
                                </IonBadge>
                            )}
                            <IonIcon icon={notificationsOutline} />
                            <h2>Értesítések</h2>
                        </IonCard>
                    </IonCol>
                    <IonCol size="6" sizeMd="3" sizeLg="4">
                        <IonCard
                            button={true}
                            className="cardButton"
                            routerLink="/my/documents"
                            routerDirection="forward"
                        >
                            <IonIcon icon={documentOutline} />
                            <h2>Dokumentumtár</h2>
                        </IonCard>
                    </IonCol>
                    <IonCol size="6" sizeMd="3" sizeLg="4">
                        <IonCard
                            button={true}
                            className="cardButton"
                            routerLink="/my/profile"
                            routerDirection="forward"
                        >
                            <IonIcon icon={readerOutline} />
                            <h2>Adataim</h2>
                        </IonCard>
                    </IonCol>
                    <IonCol size="6" sizeMd="3" sizeLg="4">
                        <IonCard
                            button={true}
                            className="cardButton"
                            routerLink="/my/invoices"
                            routerDirection="forward"
                        >
                            <IonIcon icon={fileTrayFullOutline} />
                            <h2>Számláim</h2>
                        </IonCard>
                    </IonCol>
                    <IonCol size="6" sizeMd="3" sizeLg="4">
                        <IonCard
                            button={true}
                            className="cardButton"
                            routerLink="/my/subsystems"
                            routerDirection="forward"
                        >
                            <IonIcon icon={laptopOutline} />
                            <h2>Alrendszerek</h2>
                        </IonCard>
                    </IonCol>
                    <IonCol size="6" sizeMd="3" sizeLg="4">
                        <IonCard
                            button={true}
                            className="cardButton"
                            routerLink="/my/services"
                            routerDirection="forward"
                        >
                            {/* <IonBadge color="primary">ÚJ</IonBadge> */}
                            <IonIcon icon={cartOutline} />
                            <h2>Szolgáltatások</h2>
                        </IonCard>
                    </IonCol>
                    {((assigns ?? [])[0] ?? []).find(
                        (x: any) =>
                            (x.base_data?.related_type ?? "") ===
                            "App\\Models\\BaseDataWorker"
                    ) && (
                        <IonCol size="6" sizeMd="3" sizeLg="4">
                            <IonCard
                                button={true}
                                className="cardButton"
                                routerLink="/my/own-equipments"
                                routerDirection="forward"
                            >
                                <IonBadge color="primary">ÚJ</IonBadge>
                                <IonIcon icon={bodyOutline} />
                                <h2>Dolgozói karton</h2>
                            </IonCard>
                        </IonCol>
                    )}
                </IonRow>
            </PageWrapper>

            <PhotosViewerModalWithSwiper
                documentId={selectedDocumentId}
                isOpen={selectedDocumentId !== null}
                onClose={() => setSelectedDocumentId(null)}
                onDocumentAction={handleDocumentAction}
            />

            {/* Modal for Activated Documents */}
            <IonModal
                backdropDismiss={false}
                isOpen={selectedActivatedDocument !== undefined}
            >
                {selectedActivatedDocument ? (
                    <>
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>Szolgáltatás aktiválása</IonTitle>
                                <IonButtons slot="end">
                                    <IonButton
                                        onClick={() =>
                                            setSelectedActivatedDocument(
                                                undefined
                                            )
                                        }
                                    >
                                        Mégse
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent>
                            <div className="center-modal">
                                <div>
                                    <img
                                        src={logo}
                                        alt="myPatent Logo"
                                        className="desktopLogo"
                                    />
                                    <div className="list-between">
                                        <span>Partner neve</span>
                                        <span>
                                            {selectedActivatedDocument.base_data
                                                .name ?? "-"}
                                        </span>
                                    </div>
                                    <div className="list-between">
                                        <span>Objektum cím</span>
                                        <span>
                                            {selectedActivatedDocument.related
                                                .U_myPatentObjektumCim ?? "-"}
                                        </span>
                                    </div>
                                    <div className="list-between">
                                        <span>Sorszám</span>
                                        <span>
                                            {selectedActivatedDocument.related
                                                .U_Sorszam ?? "-"}
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <IonButton
                                        color="success"
                                        expand="block"
                                        onClick={() =>
                                            handleActivateDocument(
                                                selectedActivatedDocument
                                                    .related.id
                                            )
                                        }
                                    >
                                        Aktiválás megerősítése
                                    </IonButton>
                                    <IonButton
                                        color="medium"
                                        expand="block"
                                        onClick={() =>
                                            setSelectedActivatedDocument(
                                                undefined
                                            )
                                        }
                                    >
                                        Mégse
                                    </IonButton>
                                </div>
                            </div>
                        </IonContent>
                    </>
                ) : null}
            </IonModal>
        </>
    );
};

export default DashboardPage;
